// TODO: Data from backend
// Roles codes
// Roles names
export const ADMINISTRATOR = 'administrator'; // Access to everything
export const EY_EXPERT = 'EY_EXPERT'; // Access to 1,2,3 or all providers
export const PROVIDER = 'PROVIDER'; // Access to 1:N providers
export const VIEWER = 'viewer'; // Access to View the catalog of 1:N Providers

export const ALL_USER_ROLE_NAME = [ADMINISTRATOR, EY_EXPERT, PROVIDER, VIEWER,]
